import MainLayout from "../../layouts/MainLayout";
import AboutPreviewSection from "../../sections/home/AboutPreviewSection";
import CTASection from "../../sections/home/CTASection";
import EngineeringHighlightsSection from "../../sections/home/EngineeringHighlightsSection";
import ExperienceSnapshotSection from "../../sections/home/ExperienceSnapshotSection";
import ExpertiseSection from "../../sections/home/ExpertiseSection";
import FeaturedProjectsSection from "../../sections/home/FeaturedProjectsSection";
// import LatestWritingSection from "../../sections/home/LatestWritingSection";
import HeroSection from "../../sections/home/HeroSection";

function HomePage() {
  return (
    <MainLayout>
      <HeroSection />
      <EngineeringHighlightsSection />
      <FeaturedProjectsSection />
      <ExperienceSnapshotSection />
      <ExpertiseSection />
      {/* <LatestWritingSection /> */}
      <AboutPreviewSection />
      <CTASection />
    </MainLayout>
  );
}

export default HomePage;
